import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 10H6V11H10V10Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 7.06C14 6.78948 13.9467 6.5216 13.8432 6.27167C13.7397 6.02174 13.5879 5.79465 13.3966 5.60336C13.2054 5.41207 12.9783 5.26033 12.7283 5.15681C12.4784 5.05328 12.2105 5 11.94 5H4.06C3.51365 5 2.98968 5.21704 2.60336 5.60336C2.21703 5.98969 2 6.51365 2 7.06V11H3V14H13V11H14V7.06ZM11 12H5V9H11V12ZM12.5 8C12.4011 8 12.3044 7.97068 12.2222 7.91573C12.14 7.86079 12.0759 7.7827 12.0381 7.69134C12.0002 7.59998 11.9903 7.49945 12.0096 7.40245C12.0289 7.30546 12.0765 7.21637 12.1464 7.14645C12.2164 7.07652 12.3055 7.0289 12.4025 7.00961C12.4994 6.99031 12.6 7.00022 12.6913 7.03806C12.7827 7.0759 12.8608 7.13999 12.9157 7.22221C12.9707 7.30444 13 7.40111 13 7.5C13 7.63261 12.9473 7.75979 12.8536 7.85355C12.7598 7.94732 12.6326 8 12.5 8Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2H4V4H12V2Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
